import { render, staticRenderFns } from "./BaseDivider.vue?vue&type=template&id=60284b2c&"
import script from "./BaseDivider.vue?vue&type=script&lang=js&"
export * from "./BaseDivider.vue?vue&type=script&lang=js&"
import style0 from "./BaseDivider.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports